import * as d3 from 'd3'

export default {
  methods: {

    draw_ITRs(props, x_) {
      console.log(props)
      let phase = this.canvasForms
      .append('g')
      .attr('transform', `translate(${x_}, 90)`)

      phase
      .append('rect')
      .attr('x', 0).attr('y', 8).attr('rx', 5)
      .attr('width', 260).attr('height', 125)
      .attr('fill', props.bColor).attr('fill-opacity', props.opacity)
      .attr('stroke', '#E0E0DF').attr('stroke-wisth', .5)

      phase
      .append('text')
      .attr('x', 0).attr('y', 12*0.35)
      .attr('font-size', 12).attr('fill', '#333')
      .text(props.title)


      // Draw ITRs -----------------------------------------------------------------------------------
      let item = props.item[0]
      let itr = phase
      .append('g')
      .attr('transform', `translate(65, 35)`)

      itr
      .append('text')
      .attr('x', -5).attr('y', 13 + 12*0.35).attr('font-size', 12).attr('fill', '#000')
      .attr('text-anchor', 'end')
      .text(item.id + '-ITR')

      itr
      .append('text')
      .attr('x', 0).attr('y', 17 + 9*0.75).attr('font-size', 9).attr('fill', '#bcbcbc')
      .text(props.title)

      itr
      .append('rect')
      .attr('x', 0).attr('y', 10).attr('rx', 3)
      .attr('width', props.width).attr('height', 6)
      .attr('fill', '#F2F2F2')

      itr
      .append('rect')
      .attr('x', 0).attr('y', 10).attr('rx', 3)
      .attr('width', props.width*(this.rawData[`${item.id}_PRO`] / 100)).attr('height', 6)
      .attr('fill', '#B4E3FA')

      // Progress
      itr
      .append('text')
      .attr('id', `PROG_${item.id}`)
      .attr('x', 0).attr('y', 8).attr('font-size', 14).attr('fill', '#44A9DF')
      .text(this.rawData[`${item.id}_PRO`])

      itr
      .append('text')
      .attr('x', this.getNode(`#PROG_${item.id}`) + 1).attr('y', 9)
      .attr('font-size', 10).attr('fill', '#757575')
      .text('%')

      this.columns.ITRs.forEach(col=> {
        if(col.code == 'PRO') return
        itr
        .append('text')
        .attr('x', col.ex).attr('y', 8).attr('font-size', 11).attr('fill', '#333')
        .attr('text-anchor', 'end')
        .text(this.rawData[`${item.id}_${col.code}`])
        .call(this.event_Link, col, props)

        itr
        .append('text')
        .attr('x', col.ex).attr('y', -3.5).attr('font-size', 9).attr('fill', '#757575')
        .attr('text-anchor', 'end')
        .text(col.name)
      })


      // Draw Punch -----------------------------------------------------------------------------------
      
      item = props.item[1]

      let punch = phase
      .append('g')
      .attr('transform', `translate(65, 90)`)

      punch
      .append('text')
      .attr('x', -5).attr('y', 13 + 12*0.35).attr('font-size', 12).attr('fill', '#000')
      .attr('text-anchor', 'end')
      .text(item.name + ' Punch')

      punch
      .append('text')
      .attr('x', 0).attr('y', 17 + 9*0.75).attr('font-size', 9).attr('fill', '#bcbcbc')
      .text(props.title)

      punch
      .append('rect')
      .attr('x', 0).attr('y', 10).attr('rx', 3)
      .attr('width', props.width).attr('height', 6)
      .attr('fill', '#F2F2F2')

      punch
      .append('rect')
      .attr('x', 0).attr('y', 10).attr('rx', 3)
      .attr('width', props.width*(this.rawData[`${item.id}_PRO`] / 100)).attr('height', 6)
      .attr('fill', '#FCE3EB')

      // Progress
      punch
      .append('text')
      .attr('x', 0).attr('y', 8).attr('font-size', 14).attr('fill', '#EC407A')
      .text(this.rawData[`${item.id}_REM`])
      .call(this.event_Link, this.columns.Punch[0], props)

      this.columns.Punch.forEach(col=> {
        if(col.code == 'REM') return
        punch
        .append('text')
        .attr('x', col.ex).attr('y', 8).attr('font-size', 11).attr('fill', '#333')
        .attr('text-anchor', 'end')
        .text(this.rawData[`${item.id}_${col.code}`])
        .call(this.event_Link, col, props)

        punch
        .append('text')
        .attr('x', col.ex).attr('y', -3.5).attr('font-size', 9).attr('fill', '#757575')
        .attr('text-anchor', 'end')
        .text(col.name)
      })

    },
  }
}